<template>
  <!-- <div>商品分类列表</div> -->

  <div class="shop">
    <div class="top">
      <el-button size="small" type="primary" @click="handleAdd">添加</el-button>
    </div>

    <el-table
      :data="tableData"
      style="width: 100%"
      max-height="600"
      :cell-style="tc"
      :header-cell-style="tccolor"
    >
      <el-table-column label="添加时间" prop="created_at"></el-table-column>
      <el-table-column label="商品编号" prop="product_no"></el-table-column>
      <el-table-column
        label="商品名称"
        prop="title"
        width="140"
      ></el-table-column>
      <el-table-column label="总库存" prop="goods_num"></el-table-column>
      <el-table-column label="状态" prop="show_status_name"></el-table-column>
      <el-table-column label="来源" prop="goods_source_name"></el-table-column>
      <el-table-column label="操作" fixed="right" width="240">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            @click="editSkuFn(scope.row)"
            >编辑</el-button
          >
          <el-button
            size="mini"
            class="btn"
            v-if="scope.row.show_status == 1"
            @click="frozen(scope.row.goods_id)"
            >停售</el-button
          >
          <el-button
            size="mini"
            class="btn"
            v-if="scope.row.show_status == 2"
            @click="thaw(scope.row.goods_id)"
            >恢复</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-col :span="24">
      <div class="pagination">
        <el-pagination
          background
          @current-change="pageChange"
          :current-page="form.page"
          :page-size="form.size"
          layout="total, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </el-col>

    <jdialog title="添加商品" :visible.sync="isShowCategory" width="640px">
      <el-input
        class="search input"
        style="display: block; margin: 20px auto; width: 70%"
        size="small"
        v-model="product_no_input"
        placeholder="输入商品编号"
        clearable
      ></el-input>

      <div class="align">
        <el-button size="mini" @click="isShowCategory = false">取消</el-button>
        <el-button size="mini" type="primary" @click="nextFn">下一步</el-button>
      </div>
    </jdialog>
    <jdialog
      title="产品规格"
      :visible.sync="isShowEdit"
      width="720px"
      :isComponent="true"
      @handleCancel="cancelSku"
    >

      <el-table
        :data="editData"
        style="width: 88%; margin: 20px"
        max-height="600"
        :cell-style="tc"
        :header-cell-style="tccolor"
        type="index"
      >
        <el-table-column label="规格ID">
					<template slot-scope="scope">
						{{ scope.row.sku_id }}
					</template>
				</el-table-column>
        <el-table-column label="规格名称">
					<template slot-scope="scope">
						{{ scope.row.name }}
					</template>
				</el-table-column>
        <el-table-column label="库存">
          <template slot-scope="scope">
            <el-input
              type="number"
              min="1"
              size="mini"
              v-model="scope.row.inventory"
            >
            </el-input>
          </template>
        </el-table-column>
      </el-table>

      <div style="margin: 60px; text-align: center">
        <el-button size="mini" @click="cancelSku">取消</el-button>
        <el-button size="mini" type="primary" @click="createSku"
          >保存</el-button
        >
      </div>
    </jdialog>
  </div>
</template>

<script>
import {
  getFreeGoods,
  freeSetStatus,
  freeGetSku,
  freeInspect,
  freeAddGoods,
  freeEditSku
} from '@/api/managent'
export default {
  components: {},
  data() {
    return {
      isShowCategory: false,
      isShowEdit: false,
      product_no_input: '',
      form: {
        shop_id: this.$route.query.id ? this.$route.query.id : '',
        page: 1,
        size: 20,
      },
      total: 0,
      tableData: [],
      editData: [],
      isAdd: false,
      sureProductNo:'',
      sureGoodsId:'',
      editProductId:'',
    }
  },
  mounted() {
    this.getFreeGoodsData()
  },
  watch: {},
  methods: {
    handleAdd() {
      this.product_no_input = ''
      this.isShowCategory = true
    },
    pageChange(page) {
      this.form.page = page
      //获取更多数据
      this.getFreeGoodsData()
    },
    getSkuFn(product_no,shop_id,product_id) {
      freeGetSku({ product_no,shop_id,product_id }).then((res) => {
        if (res.code === 10000) {
          this.sureProductNo = product_no
          this.editData = res.data
        } else {
          this.$message.error(res.message)
        }
      })
    },
    nextFn() {
      freeInspect({
        shop_id: this.form.shop_id,
        product_no: this.product_no_input,
      }).then((res) => {
        console.log(res.code)
        if (res.code === 10000) {
          this.isShowCategory = false
          this.isShowEdit = true
          this.isAdd = true
          this.getSkuFn(this.product_no_input,this.form.shop_id)

        } else {
          this.$message.error(res.message)
        }
      })
    },
    editSkuFn(item){
      this.isShowEdit = true
      this.isAdd = false
      this.sureGoodsId = item.goods_id
      this.editProductId = item.product_id
      this.getSkuFn(item.product_no,this.form.shop_id,item.product_id)
    },
    cancelSku(){
      this.isShowEdit = false;
      this.editData = [];
      this.sureGoodsId = ''
    },
    createSku(){
      if(this.isAdd){
        this.freeAddGoodsFn()
      }else{
        this.freeEditSkuFn()
      }
    },
    freeAddGoodsFn() {
      const sku_list = JSON.stringify(this.editData);
      freeAddGoods({ product_no:this.sureProductNo,shop_id:this.form.shop_id,sku_list }).then((res) => {
        if (res.code === 10000) {
          this.getFreeGoodsData()
          this.$message.success('保存成功')
          this.isShowEdit = false
        } else {
          this.$message.error(res.message)
        }
      })
    },
    freeEditSkuFn() {
      const sku_list = JSON.stringify(this.editData); 
      freeEditSku({ product_no:this.sureProductNo,shop_id:this.form.shop_id,sku_list,goods_id:this.sureGoodsId,product_id:this.editProductId }).then((res) => {
        if (res.code === 10000) {
          this.getFreeGoodsData()
          this.$message.success('保存成功')
          this.isShowEdit = false
        } else {
          this.$message.error(res.message)
        }
      })
    },
    //获取商品分类列表数据
    async getFreeGoodsData() {
      var url =
        'page=' +
        this.form.page +
        '&size=' +
        this.form.size +
        '&shop_id=' +
        this.form.shop_id
      let res = await getFreeGoods(url)
      if (res.code === 10000) {
        this.tableData = res.data.data
        this.total = res.data.total
      } else {
        this.$message.error(res.message)
      }
    },
    // 停售
    frozen(goods_id) {
      freeSetStatus({ goods_id, show_status: 2 }).then((res) => {
        console.log(res.code)
        if (res.code === 10000) {
          this.getFreeGoodsData()
          this.$message.success('操作成功')
        } else {
          this.$message.error(res.message)
        }
      })
    },
    // 恢复
    thaw(goods_id) {
      freeSetStatus({ goods_id, show_status: 1 }).then((res) => {
        if (res.code === 10000) {
          this.getFreeGoodsData()
          this.$message.success('操作成功')
        } else {
          this.$message.error(res.message)
        }
      })
    },
    tc() {
      return 'text-align:center; color:#333333; font-size:12px;'
    },
    tccolor() {
      return 'text-align:center;background-color:#f5f5f5; font-size:14px;'
    },
  },
}
</script>

<style lang="scss" scoped>
.shop {
  padding: 20px;
  .top {
    margin-bottom: 20px;
    .search {
      float: right;
      margin-left: 12px;
    }
    .input {
      width: 150px;
    }
  }

  .cetain {
    color: #f4222d;
  }
  .pagination {
    float: right;
    margin-top: 12px;
  }

  .icon_cate {
    float: left;
  }
  .demo-ruleForm {
    padding: 20px;
  }
  .note {
    color: #666666;
    font-size: 14px;
    margin-top: 28px;
  }
  .align {
    text-align: center;
  }
}
</style>
